export enum LabelType {
  departure,
  arrival,
}
